<template>
    <div class="modal fade" id="updateUserPasswordModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                </div>
                <form method="post" @submit.prevent="updateUser()">
                    <div class="modal-body">

                        <div class="form-group">
                            <label>Enter New Password</label>
                            <input v-model="new_password" type="password" required="required" class="form-control" placeholder="Password..."/>
                        </div>

                        <div class="form-group">
                            <label>Repeat Password</label>
                            <input v-model="repeat_password" type="password" required="required" class="form-control" placeholder="Password..."/>
                        </div>

                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Save</button>
                </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "UpdateUsersPassword",
        data: function() {
            return {
                user_id:0,
                new_password: "",
                repeat_password:"",
            };
        },
        mounted: function () {
            $('#updateUserPasswordModal').on('hidden.bs.modal',  (e) => {
                if(this.$parent.dtTable !== undefined && this.$parent.dtTable !== null){
                    this.$parent.dtTable.draw();
                }
                this.resetData();
            });
        },
        methods: {
            load: function (userID){
              if(userID > 0){
                 this.user_id=userID;
              }
              $("#updateUserPasswordModal").modal("show");
            },
            updateUser: function () {
                let params = new URLSearchParams();
                params.append("user_id", this.user_id);
                params.append("new_password", this.new_password);
                params.append("repeat_password", this.repeat_password);


                this.$http.post(this.$store.state.mainAppURL + "users/update_user_password_admin", params).then(resp => {
                   if(resp.data){
                       $("#updateUserPasswordModal").modal("hide");
                       swal("Success!" ," Password Updated Successfully");

                   }else{
                       swal("Error!" ," Please Try Again", "error");
                   }
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call());
            }
        }
    }
</script>

<style scoped>

</style>
